import type { PortErrorCode } from "../../ports/common/port-error";

export type HomeLoadErrorKind = "FORBIDDEN" | "NOT_FOUND" | "DEPENDENCY_UNAVAILABLE" | "GENERIC";

export const mapHomeLoadError = (code: PortErrorCode): HomeLoadErrorKind => {
  switch (code) {
    case "UNAUTHORIZED":
    case "FORBIDDEN":
      return "FORBIDDEN";
    case "NOT_FOUND":
      return "NOT_FOUND";
    case "UNAVAILABLE":
    case "TIMEOUT":
    case "RATE_LIMITED":
    case "INVALID_RESPONSE":
    case "REJECTED":
      return "DEPENDENCY_UNAVAILABLE";
    case "CONFLICT":
    case "VALIDATION_ERROR":
    case "UNKNOWN":
      return "GENERIC";
    default:
      return assertNever(code);
  }
};

const assertNever = (value: never): never => {
  throw new Error(`Unhandled PortErrorCode: ${String(value)}`);
};
